module.exports = __webpack_public_path__ + "app/kiss-seller/kiss-seller-relations-10LNoZel.html";